import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useTask, useUpdateTask } from "../hooks";
import { TaskForm } from "../components";

type IUpdateTask = {
  id: string;
};

export const UpdateTask: React.FC = () => {
  const { id } = useParams<IUpdateTask>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useTask(+id!);
  const { form, submit, loading } = useUpdateTask({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("La tâche a été modifiée avec succès");
    },
  });

  useEffect(() => {
    if (data?.task?.ok && data?.task?.result) {
      const { result } = data.task;
      form.setValue("title", result.title);
      form.setValue("description", result.description);
      form.setValue("status", result.status);
      form.setValue("priority", result.priority);
      form.setValue("dueDate", result.dueDate);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  if (data?.task?.ok === false) {
    return (
      <div className="main-container">
        <div className="card">
          <p className="text-red-600">
            {data?.task?.error ?? "Vous n'avez pas accès à cette tâche"}
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header
        title="Tâche"
        subtitle={data?.task?.result?.title}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/task/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier une tâche" />
          <TaskForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
